import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/eledgers`;

export const eledgerService = {
  // Get all E-ledgers
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.entity_type) params.append('entity_type', filters.entity_type);
    if (filters.status) params.append('status', filters.status);
    if (filters.node_id) params.append('node_id', filters.node_id);
    if (filters.include_node) params.append('include_node', filters.include_node);
    if (filters.period_id) params.append('period_id', filters.period_id);
    const response = await axios.get(`${API_BASE}?${params}`);
    return response.data;
  },

  // Get facility E-Ledgers with OFP context (for PCF calculation)
  getFacilityLedgers: async () => {
    const response = await axios.get(`${API_BASE}/facilities`);
    return response.data;
  },

  // Get E-ledger by ID
  getById: async (id, includeEntries = false) => {
    const response = await axios.get(`${API_BASE}/${id}?include_entries=${includeEntries}`);
    return response.data;
  },

  // Create new E-ledger
  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  // Update E-ledger
  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  // Delete E-ledger
  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  // Get E-ledger balance
  getBalance: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}/balance`);
    return response.data;
  },

  // Get E-ledger entries
  getEntries: async (id, filters = {}) => {
    const params = new URLSearchParams();
    if (filters.entry_type) params.append('entry_type', filters.entry_type);
    if (filters.source_type) params.append('source_type', filters.source_type);
    const response = await axios.get(`${API_BASE}/${id}/entries?${params}`);
    return response.data;
  },

  // Close accounting period
  closePeriod: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/close-period`);
    return response.data;
  },

  // Validate ledger integrity
  validate: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}/validate`);
    return response.data;
  }
};

export default eledgerService;
